<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="申请编号">
              <a-input v-model="query.establishmentNo" placeholder="请输入申请编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="申请人">
              <a-input v-model="query.establishmentUserName" placeholder="请输入申请人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请内容">
              <a-input v-model="query.content" placeholder="请输入申请内容" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="审批状态">
              <a-select v-model="query.approveStatus" allow-clear placeholder="请选择审批状态">
                <a-select-option :value="0"> 待审批 </a-select-option>
                <a-select-option :value="1"> 已审批 </a-select-option>
                <a-select-option :value="2"> 审批不通过 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                show-time
                placeholder="选择开始时间"
                v-model="startTime"
                @change="changes"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结束时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                show-time
                placeholder="选择结束时间"
                @change="changet"
                v-model="endTime"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="approval(id)" v-action:approva>审批</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdate()" v-action:append>新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:delete
                >删除</a-button
              >
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="id"
      bordered
      :scroll="{ x: 1400 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="dataUrl" slot-scope="text, record">
        <span>{{ record.dataUrl[0].name }}</span>
      </span>
      <span slot="approveStatus" slot-scope="text, record">
        <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
        <a-tag v-if="record.approveStatus === 1" color="#32CD32">已审批</a-tag>
        <a-tag v-if="record.approveStatus === 2" color="#FF6347">审批不通过</a-tag>
      </span>
      <div slot="action" slot-scope="text, record" style="display: flex; justify-content: space-between">
        <!-- <a-button size="small" type="danger" style="font-size: 12px" @click="addOrUpdateHandle(record.id)">
              查看详情
            </a-button> -->
        <a-button
          size="small"
          type="primary"
          style="font-size: 12px"
          @click="addOrUpdateHandle(record.id)"
          :disabled="record.createUserId !== climbId || record.approveStatus !== 2"
        >
          编辑
        </a-button>
      </div>
    </a-table>
    <!-- 新增 修改 -->
    <a-modal
      :title="titieh"
      style="top: 20px"
      :width="800"
      :visible="addOrUpdateVisible"
      :destroyOnClose="true"
      @cancel="handleCancelh"
    >
      <a-form-model class="tenant-form" :model="engineeringProjectEstab" ref="engineeringProjectEstab" :rules="rules">
        <a-form-model-item
          :label="titieh + '编号'"
          prop="establishmentNo"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input disabled v-model="engineeringProjectEstab.establishmentNo" placeholder="系统自动按规则生成" />
        </a-form-model-item>
        <a-form-model-item label="项目名称" prop="establishmentName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.establishmentName" />
        </a-form-model-item>
        <a-form-model-item :label="titieh + '内容'" prop="content" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.content" />
        </a-form-model-item>

        <a-form-model-item
          :label="titieh + '类型'"
          prop="establishmentType"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select v-model="engineeringProjectEstab.establishmentType">
            <a-select-option v-for="item in AppliCAtion" :key="item.dictValue">{{ item.dictValue }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="申请人" prop="establishmentUserName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.establishmentUserName" />
        </a-form-model-item>
        <!-- <a-form-model-item label="创建人" prop="createName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.createName" />
        </a-form-model-item> -->
        <a-form-model-item label="联系方式" prop="phone" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.phone" />
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.address" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="审批状态">
          <a-input placeholder="通过审批按钮自动生成" disabled style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
          <a-textarea v-model="engineeringProjectEstab.remark" :rows="4" style="width: 690px" />
        </a-form-model-item>
        <a-form-model-item label="附件上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload-dragger name="file" :multiple="true" :customRequest="customRequest" :showUploadList="false">
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              文件拖拽此处或
              <a>点击上传</a>
            </p>
          </a-upload-dragger>
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in engineeringProjectEstab.fileNames" :key="item.url">
                <div class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" />
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
      <template #footer>
        <a-button @click="handleCancelh">取消</a-button>
        <a-button v-if="shwoadd" type="primary" @click="handleOkaddOrUpdate">确定</a-button>
        <a-button v-if="shwoadds" type="primary" @click="handleOkaUpdate">确定</a-button>
      </template>
    </a-modal>
    <!-- 审批 -->
    <a-modal title="审批" style="top: 20px" :width="800" :visible="visible" @ok="approvalHandle" @cancel="handleCancel">
      <a-form-model
        class="log-form"
        :model="engineeringProjectEstab"
        ref="ruleForm"
        :rules="rule"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 22 }"
      >
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="审批" prop="approveStatus">
          <a-radio-group v-model="engineeringProjectEstab.approveStatus" @change="onChangejt">
            <a-radio :value="1"> 通过 </a-radio>
            <a-radio :value="2"> 驳回 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if="apprOpinion">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划开始时间" prop="startValue">
            <a-date-picker
              v-model="engineeringProjectEstab.startValue"
              :disabled-date="disabledStartDate"
              show-time
              @change="onChangeh"
              format="YYYY-MM-DD HH:mm:ss"
              @openChange="handleStartOpenChange"
            />
          </a-form-model-item>
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划结束时间" prop="endValue">
            <a-date-picker
              v-model="engineeringProjectEstab.endValue"
              :disabled-date="disabledEndDate"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              :open="endOpen"
              @change="onChanget"
              @openChange="handleEndOpenChange"
            />
          </a-form-model-item>
        </div>

        <a-form-model-item label="审批意见" prop="approvalOpinion" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.approvalOpinion" />
        </a-form-model-item>
        <a-form-model-item label="执行人" prop="establishmentUserId" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select placeholder="选择一个执行人" v-model="engineeringProjectEstab.establishmentUserId">
            <a-select-option v-for="item in userlist" :key="item.key.principalId" :value="item.key.principalId">
              {{ item.key.principal }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in engineeringProjectEstab.fileNames" :key="item.url">
                <div class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" />
              </li>
            </ul>
          </div>
        </a-form-model-item>
        <a-form-model-item label="备注" style="display: flex" prop="remark">
          <a-textarea v-model="engineeringProjectEstab.remark" placeholder="多行输入" :rows="4" style="width: 690px" />
        </a-form-model-item>
      </a-form-model>
      <!-- </a-form> -->
    </a-modal>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      visible: false,
      queryUrl: '/pipe-network/engineering_project_applys/page', //列表请求数据接口
      queryOneUrl: '/pipe-network/engineering_project_applys/', //查询单条地址
      deleteUrl: '/pipe-network/engineering_project_applys', //删除
      uploadUrl: 'manager/file/resources/upload', // 上传文件URL
      staffTreeData: [], // 分区数据选项
      bookTreeData: [], // 分区数据选项
      userlist: [],
      currId: 0,
      AppliCAtion: [],
      shows: false,
      showst: false,
      endOpen: false,
      apprOpinion: true,
      climbId: '',
      startTime: '',
      endTime: '',
      titieh: '申请',
      query: {
        establishmentNo: '',
        establishmentType: '',
        executeUserName: '',
        approveStatus: '',
        content: '',
        createTime: '',
        startTime: '',
        endTime: '',
      }, // 查询参数
      addOrUpdateVisible: false, // 新增修改是否可见
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      engineeringProjectEstab: {
        projectType: '申请', //项目类型
        establishmentNo: '', //项目编码
        establishmentName: '', //项目名称
        content: '', //内容
        establishmentType: '', //立项类型
        establishmentUserName: '', //申请人
        establishmentUserId: '', //	执行人
        phone: '', //联系方式
        address: '', //地址
        createTime: '', //时间
        startTime: '', //计划开始时间
        endTime: '', //计划结束时间
        remark: '', //备注
        fileNames: [], //上传资料
        approvalOpinion: '',
        createName: '',
        startValue: null,
        endValue: null,
      },
      shwoadds: false,
      shwoadd: false,
      rules: {
        createName: [{ required: true, message: '请输入创建人', trigger: 'change' }],
        establishmentName: [{ required: true, message: '请输入项目名称', trigger: 'change' }],
        content: [{ required: true, message: '请输入内容', trigger: 'change' }],
        establishmentType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        establishmentUserName: [{ required: true, message: '请输入申请人', trigger: 'blchangeur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'change' },
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确联系方式', trigger: 'change' },
        ],
      },
      rule: {
        approveStatus: [{ required: true, message: '请审批', trigger: 'change' }],
        executeUserId: [{ required: true, message: '请选择执行人', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }],
        approvalOpinion: [{ required: true, message: '请输入审批意见', trigger: 'change' }],
      },
      columns: [
        {
          title: '申请编号',
          dataIndex: 'establishmentNo',
          width: 200,
        },
        {
          title: '申请名称',
          dataIndex: 'establishmentName',
          ellipsis: true,
          width: 200,
        },
        {
          title: '申请人',
          dataIndex: 'establishmentUserName',
          width: 200,
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          width: 200,
        },
        {
          title: '联系方式',
          dataIndex: 'phone',
          width: 200,
        },
        {
          title: '地址',
          dataIndex: 'address',
          ellipsis: true,
          width: 200,
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          width: 200,
        },
        {
          title: '内容',
          dataIndex: 'content',
          ellipsis: true,
          width: 200,
        },
        {
          title: '审批意见',
          dataIndex: 'approvalOpinion',
          ellipsis: true,
          width: 200,
        },
        {
          title: '审批状态',
          dataIndex: 'approveStatus',
          scopedSlots: { customRender: 'approveStatus' },
          width: 150,
        },
        {
          title: '申请类型',
          dataIndex: 'establishmentType',
          width: 150,
        },
        {
          title: '操作',
          align: 'center',
          key: 'operation',
          fixed: 'right',
          width: 100,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  created() {
    this.queryList()
    this.Responsibleinterface()
    this.getTaskList()
    this.resetList()
    this.currentUser()
  },
  methods: {
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.startTime = ''
      this.endTime = ''
      this.queryList()
    },
    changes(a, i) {
      if (i == '') {
        this.query.startTime = i
      } else {
        this.query.startTime = i + ' 00:00:00'
      }
    },
    changet(a, i) {
      if (i == '') {
        this.query.endTime = i
      } else {
        this.query.endTime = i + ' 00:00:00'
      }
    },
    currentUser() {
      // this.engineeringProjectEstab.establishmentUserName = this.$store.getters.userInfo.nickName
      this.engineeringProjectEstab.createName = this.$store.getters.userInfo.nickName
      this.climbId = this.$store.getters.userInfo.id
    },
    //时间
    disabledStartDate(startValue) {
      const endValue = this.engineeringProjectEstab.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = this.engineeringProjectEstab.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    onChangejt(value) {
      if (value.target.value == 2) {
        this.apprOpinion = false
      } else {
        this.apprOpinion = true
      }
    },
    onChangeh(date, dateString) {
      this.engineeringProjectEstab.startTime = dateString
    },
    onChanget(date, dateString) {
      this.engineeringProjectEstab.endTime = dateString
    },
    //负责人下拉框
    Responsibleinterface() {
      this.$http.get('/pipe-network/engineering_project_establishments/principals').then(({ data }) => {
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.real_name,
            key: item,
            name: item.real_name,
          })
        })
        this.userlist = list
      })
    },
    //字典
    getTaskList() {
      const params = {
        dictCode: 'APPLICATION-TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        
        this.AppliCAtion = data
        console.log(data, '字典')
      })
    },
    //新增更新
    addOrUpdate() {
      console.log(this.engineeringProjectEstab.fileNames.splice(0, this.engineeringProjectEstab.fileNames.length))
      this.shwoadd = true
      this.shwoadds = false
      this.addOrUpdateVisible = true
    },
    handleOkaUpdate() {
      this.$refs.engineeringProjectEstab.validate((valid) => {
        if (valid) {
          this.$http
            .put('/pipe-network/engineering_project_applys', { id: this.currentId, ...this.engineeringProjectEstab })
            .then((res) => {
              if (res.code == 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.engineeringProjectEstab.fileNames = []
                return this.$message.success(res.message)
              } else {
                this.addOrUpdateVisible = false
                return this.$message.warn(res.message)
              }
            })
          this.$refs.engineeringProjectEstab.resetFields()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleOkaddOrUpdate() {
      this.$refs.engineeringProjectEstab.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/engineering_project_applys', { ...this.engineeringProjectEstab })
            .then((res) => {
              if (res.code == 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.engineeringProjectEstab.fileNames = []
                return this.$message.success(res.message)
              } else {
                this.addOrUpdateVisible = false
                return this.$message.warn(res.message)
              }
            })
          this.$refs.engineeringProjectEstab.resetFields()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleCancelh() {
      console.log('quxiao')
      this.engineeringProjectEstab.fileNames = []
      this.addOrUpdateVisible = false
      this.$refs.engineeringProjectEstab.resetFields()
    },
    //审批
    approval() {
      console.log(this.selectedRows, 'dangqianghang')
      if (this.selectedRows.length == 1) {
        this.currId = this.selectedRows[0]
        this.currentId = this.selectedRows[0]
        this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then(({ data }) => {
          this.engineeringProjectEstab = {
            remark: data.remark, //备注
            fileNames: data.fileNames,
          }
        })
        console.log(this.selectedRows[0])
        this.visible = true
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要审批的事件')
      } else {
        return this.$message.warn('只能选择一条要审批的事件')
      }
    },
    // 确认审批
    approvalHandle() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$http
            .put('/pipe-network/engineering_project_applys', {
              id: this.currId,
              ...this.engineeringProjectEstab,
            })
            .then((res) => {
              console.log(res.data, '审批')
              if (res.message == '操作成功') {
                this.$message.success(res.message)
                this.visible = false
                this.queryList()
              } else {
                this.$message.success('操作失败')
              }
            })
          this.$refs.engineeringProjectEstab.resetFields()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //取消
    handleCancel() {
      this.$refs.ruleForm.resetFields()
      this.queryList()
      this.visible = false
    },
    // 根据id 修改
    addOrUpdateHandle(id) {
      this.shwoadd = false
      this.shwoadds = true
      this.isUpdate = false
      this.addOrUpdateVisible = true
      this.currentId = id
      //  this.currentId = id
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.engineeringProjectEstab = {
              projectType: this.titieh, //项目类型
              establishmentNo: data.establishmentNo, //项目编码
              establishmentName: data.establishmentName, //项目名称
              content: data.content, //内容
              establishmentType: data.establishmentType, //立项类型
              phone: data.phone, //联系方式
              address: data.address, //地址
              createTime: data.createTime, //时间
              startTime: data.startTime, //计划开始时间
              endTime: data.endTime, //计划结束时间
              remark: data.remark, //备注
              fileNames: data.fileNames,
              establishmentUserName: data.establishmentUserName, //申请人
              approveStatus: data.approveStatus, //审批状态值
              createName: data.createName,
            }
          })
          .catch(() => {})
      }
    },
    onChange(date, dateString) {
      console.log(date, dateString)
    },
    customRequest(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            let obj = {
              url: response.data.url,
              name: response.data.fileName,
            }
            this.engineeringProjectEstab.fileNames.push(obj)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    uploadFile(item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile(url) {
      let index = this.engineeringProjectEstab.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.engineeringProjectEstab.fileNames.splice(index, 1)
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
